export default "__VITE_ASSET__c1576837__"